<template>
  <v-card>
    <v-card-text>
      <!-- LISTA NORMAL DE VAGAS (cards) -->
      <template v-if="!showBancoTalentos">
        <v-row class="mt-2" align="stretch" justify="start">
          <!-- ✅ BANCO DE TALENTOS (SEMPRE FIXO) -->
          <v-col cols="12" sm="6" lg="4">
            <v-card
              class="mx-auto elevation-2 rounded-lg overflow-hidden d-flex flex-column"
              hover
              style="width: 100%; height: 100%"
            >
              <v-img
                :src="bancoTalentosImg"
                height="260"
                class="white--text"
                contain
              />

              <v-card-text class="pa-3 white d-flex flex-column flex-grow-1">
                <div class="flex-grow-1">
                  <div class="caption grey--text text--darken-2">
                    Não encontrou a vaga de seu interesse?
                  </div>
                  <div class="caption grey--text text--darken-2 mt-1">
                    Nosso Banco de Talentos é o espaço onde você pode cadastrar
                    seu currículo para futuras oportunidades.
                  </div>
                </div>

                <div class="mt-3">
                  <v-btn
                    block
                    color="primary"
                    small
                    rounded
                    class="text-none font-weight-bold"
                    elevation="0"
                    depressed
                    @click="showBancoTalentos = true"
                  >
                    Candidatar-se
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- LOADING -->
          <template v-if="carregando">
            <v-col v-for="n in 2" :key="'sk-' + n" cols="12" sm="6" lg="4">
              <v-skeleton-loader type="card" class="mx-auto" />
            </v-col>
          </template>

          <!-- CARDS DINÂMICOS -->
          <template v-else>
            <v-col
              v-for="(vaga, index) in vagas"
              :key="vaga.id || index"
              cols="12"
              sm="6"
              lg="4"
            >
              <v-card
                class="mx-auto elevation-2 rounded-lg overflow-hidden d-flex flex-column"
                hover
                style="width: 100%; height: 100%"
              >
                <v-img
                  v-if="vaga.imagemBase64"
                  :src="vaga.imagemBase64"
                  height="260"
                  class="white--text"
                  contain
                  @click="abrirDetalhesVaga(vaga)"
                  style="cursor: pointer"
                />
                <div
                  v-else
                  class="grey lighten-4 d-flex align-center justify-center"
                  style="height: 260px; width: 100%; cursor: pointer"
                  @click="abrirDetalhesVaga(vaga)"
                >
                  <div class="text-center grey--text caption">
                    <v-icon color="grey lighten-1" large>
                      mdi-image-off-outline
                    </v-icon>
                    <div class="mt-1">Imagem da Vaga</div>
                  </div>
                </div>

                <v-card-text class="pa-3 white d-flex flex-column flex-grow-1">
                  <div class="flex-grow-1">
                    <div class="mb-3">
                      <div
                        class="text-subtitle-1 font-weight-bold primary--text text-truncate"
                      >
                        {{ vaga.titulo }}
                      </div>

                      <div
                        class="caption font-weight-medium grey--text text--darken-2"
                      >
                        <div class="text-truncate">
                          <span class="font-weight-bold">Cidade:</span>
                          {{ vaga.cidade || "-" }}
                        </div>

                        <div class="text-truncate">
                          <span class="font-weight-bold">Local:</span>
                          {{
                            vaga.local ||
                            (vaga.estabelecimento &&
                            vaga.estabelecimento.descricao
                              ? vaga.estabelecimento.descricao
                              : "-")
                          }}
                        </div>

                        <div v-if="vaga.requisicao" class="text-truncate">
                          <span class="font-weight-bold">Req:</span>
                          {{ vaga.requisicao }}
                        </div>
                      </div>
                    </div>

                    <div class="mt-2">
                      <div class="caption mb-0">
                        <span class="font-weight-bold"
                          >Prazo para candidatura:</span
                        >
                      </div>
                      <div class="text-subtitle-2 font-weight-bold error--text">
                        {{ formatData(vaga.prazo) }}
                      </div>
                    </div>
                  </div>

                  <div class="mt-3">
                    <v-btn
                      block
                      color="primary"
                      small
                      rounded
                      class="text-none font-weight-bold"
                      elevation="0"
                      depressed
                      @click="candidatarVaga(vaga)"
                    >
                      Candidatar-se
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </template>
        </v-row>

        <!-- ✅ DIALOG DETALHES (ZOOM) -->
        <v-dialog v-model="dialogDetalhes" max-width="800">
          <v-card v-if="vagaTemp">
            <v-img
              :src="vagaTemp.imagemBase64 || vagaTemp.imagemUrl"
              height="400"
              contain
              class="grey lighten-2"
            />
            <v-card-title class="headline">{{ vagaTemp.titulo }}</v-card-title>
            <v-card-text>
              <div class="subtitle-1">
                <div v-if="vagaTemp.cidade">
                  <span class="font-weight-bold">Cidade:</span>
                  {{ vagaTemp.cidade }}
                </div>
                <div>
                  <span class="font-weight-bold">Local:</span>
                  {{
                    vagaTemp.local ||
                    (vagaTemp.estabelecimento &&
                    vagaTemp.estabelecimento.descricao
                      ? vagaTemp.estabelecimento.descricao
                      : "-")
                  }}
                </div>
                <div v-if="vagaTemp.requisicao">
                  <span class="font-weight-bold">Requisição:</span>
                  {{ vagaTemp.requisicao }}
                </div>
                <div>
                  <span class="font-weight-bold">Prazo:</span>
                  {{ formatData(vagaTemp.prazo) }}
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="grey darken-1" @click="dialogDetalhes = false">
                Fechar
              </v-btn>
              <v-btn
                color="primary"
                rounded
                class="text-none font-weight-bold"
                depressed
                @click="candidatarVaga(vagaTemp)"
              >
                Candidatar-se
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- ✅ DIALOG CONFIRMAÇÃO (VAGA NORMAL) -->
        <v-dialog v-model="dialogConfirmaVaga" max-width="520">
          <v-card>
            <v-card-title class="headline d-flex align-center">
              <v-icon color="primary" class="mr-2">mdi-briefcase</v-icon>
              Confirmar candidatura
            </v-card-title>
            <v-divider></v-divider>

            <v-card-text>
              <div class="subtitle-2 grey--text text--darken-2 mb-2">
                Deseja se candidatar para a vaga abaixo?
              </div>

              <div class="text-subtitle-1 font-weight-bold primary--text">
                {{ vagaTemp ? vagaTemp.titulo : "" }}
              </div>

              <div class="caption mt-1">
                <div
                  v-if="
                    vagaTemp &&
                    (vagaTemp.local ||
                      (vagaTemp.estabelecimento &&
                        vagaTemp.estabelecimento.descricao))
                  "
                >
                  <span class="font-weight-bold">Local:</span>
                  {{
                    vagaTemp.local ||
                    (vagaTemp.estabelecimento
                      ? vagaTemp.estabelecimento.descricao
                      : "")
                  }}
                </div>

                <div v-if="vagaTemp && vagaTemp.cidade">
                  <span class="font-weight-bold">Cidade:</span>
                  {{ vagaTemp.cidade }}
                </div>

                <div v-if="vagaTemp && vagaTemp.prazo">
                  <span class="font-weight-bold">Prazo:</span>
                  {{ formatData(vagaTemp.prazo) }}
                </div>
              </div>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                color="grey darken-1"
                rounded
                @click="dialogConfirmaVaga = false"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="primary"
                rounded
                class="text-none font-weight-bold"
                elevation="0"
                depressed
                @click="confirmarCandidatura"
              >
                Confirmar candidatura
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>

      <!-- BANCO DE TALENTOS -->
      <template v-else>
        <div class="pa-4">
          <div class="text-h6 font-weight-bold mb-3">Banco de Talentos</div>

          <div class="subtitle-2 grey--text text--darken-1 mb-4">
            Nosso Banco de Talentos foi criado para conectar colaboradores com
            potencial às futuras oportunidades.
          </div>

          <div class="subtitle-2 grey--text text--darken-1 mb-4">
            Selecione abaixo qual a unidade/área de seu interesse!
          </div>

          <!-- UNIDADE -->
          <v-card outlined class="mb-4">
            <v-list two-line>
              <v-list-item
                v-for="(u, i) in unidadesDiretas"
                :key="i"
                @click="selecionaUnidade(u)"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ u }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon>
                    {{
                      bancoSelecao.unidade === u
                        ? "mdi-radiobox-marked"
                        : "mdi-radiobox-blank"
                    }}
                  </v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card>

          <v-expansion-panels focusable multiple class="mb-4">
            <v-expansion-panel>
              <v-expansion-panel-header
                >Abatedouro de Aves</v-expansion-panel-header
              >
              <v-expansion-panel-content>
                <v-subheader>Operador de produção</v-subheader>
                <v-radio-group
                  v-model="bancoSelecao.operadorProducao"
                  hide-details
                  @change="onSelecionaGrupo('operadorProducao')"
                >
                  <v-radio
                    v-for="op in abatedouro.operadorProducao"
                    :key="op.id"
                    :label="op.label"
                    :value="op.id"
                  />
                </v-radio-group>

                <v-subheader class="mt-4">Serviços externos</v-subheader>
                <v-radio-group
                  v-model="bancoSelecao.servicosExternos"
                  hide-details
                  @change="onSelecionaGrupo('servicosExternos')"
                >
                  <v-radio
                    v-for="op in abatedouro.servicosExternos"
                    :key="op.id"
                    :label="op.label"
                    :value="op.id"
                  />
                </v-radio-group>

                <v-subheader class="mt-4">Manutenção</v-subheader>
                <v-radio-group
                  v-model="bancoSelecao.manutencao"
                  hide-details
                  @change="onSelecionaGrupo('manutencao')"
                >
                  <v-radio
                    v-for="op in abatedouro.manutencao"
                    :key="op.id"
                    :label="op.label"
                    :value="op.id"
                  />
                </v-radio-group>

                <v-subheader class="mt-4">Outras áreas</v-subheader>
                <v-radio-group
                  v-model="bancoSelecao.outrasAreas"
                  hide-details
                  @change="onSelecionaGrupo('outrasAreas')"
                >
                  <v-radio
                    v-for="op in abatedouro.outrasAreas"
                    :key="op.id"
                    :label="op.label"
                    :value="op.id"
                  />
                </v-radio-group>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header
                >Centro Administrativo</v-expansion-panel-header
              >
              <v-expansion-panel-content>
                <v-radio-group
                  v-model="bancoSelecao.administrativo"
                  hide-details
                  @change="onSelecionaGrupo('administrativo')"
                >
                  <v-radio
                    v-for="op in administrativo"
                    :key="op.id"
                    :label="op.label"
                    :value="op.id"
                  />
                </v-radio-group>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <div class="d-flex align-center">
            <v-btn
              class="info"
              rounded
              depressed
              min-width="130"
              :disabled="!podeContinuar"
              @click="continuarBanco"
            >
              Continuar <v-icon class="ml-2">mdi-arrow-right</v-icon>
            </v-btn>

            <v-btn
              text
              rounded
              small
              class="ml-2"
              @click="showBancoTalentos = false"
            >
              Voltar
            </v-btn>
          </div>
        </div>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from "axios";
import { mapMutations } from "vuex";

export default {
  data: () => ({
    vagas: [],
    showBancoTalentos: false,
    bancoTalentosImg: process.env.BASE_URL + "img/bancotalentos.png",

    // ✅ confirmação vaga normal
    dialogConfirmaVaga: false,
    dialogDetalhes: false,
    vagaTemp: null,

    unidadesDiretas: [
      "FFO - Fábrica",
      "Entreposto",
      "Fábricas",
      "Posto de Combustivel",
      "Supermercado",
    ],

    bancoSelecao: {
      unidade: null,
      operadorProducao: null,
      servicosExternos: null,
      manutencao: null,
      outrasAreas: null,
      administrativo: null,
    },

    abatedouro: {
      operadorProducao: [
        {
          id: "ABATE 1 RECEPCAO",
          label: "Recepção de Aves – 1º turno (04h40 às 14h00)",
        },
        {
          id: "ABATE 2 RECEPCAO",
          label: "Recepção de Aves – 2º turno (14h00 às 23h30)",
        },
        { id: "ABATE 1 CORTES", label: "Cortes – 1º turno (06h30 às 16h00)" },
        { id: "ABATE 2 CORTES", label: "Cortes – 2º turno (16h00 à 01h30)" },
        {
          id: "ABATE 1 ESTOQUE/EXPEDICAO",
          label: "Paletização/Expedição – 1º turno (06h30 às 16h00)",
        },
        {
          id: "ABATE 2 ESTOQUE/EXPEDICAO",
          label: "Paletização/Expedição – 2º turno (16h00 à 01h30)",
        },
        { id: "ABATE 1 SIF", label: "SIF – 1º turno (04h30 às 14h00)" },
        { id: "ABATE 2 SIF", label: "SIF – 2º turno (14h30 às 23h30)" },
        { id: "ABATE HIGIENIZACAO", label: "Higienização (3º turno)" },
      ],
      servicosExternos: [
        { id: "ABATE REFEITORIO", label: "Refeitório/Cozinha" },
        { id: "ABATE LIMPEZA", label: "Limpeza" },
        { id: "ABATE ALMOXARIFADO", label: "Almoxarifado" },
      ],
      manutencao: [
        {
          id: "ABATE MANUTENCAO",
          label: "Elétrica/Mecânica/Hidráulica / Refrigeração / Ambiental",
        },
      ],
      outrasAreas: [
        { id: "ABATE LIDER", label: "Líder/Supervisor" },
        { id: "ABATE OPERADOR-MAQUINA", label: "Operador de Máquina" },
        { id: "ABATE COMERCIAL FRANGO", label: "Comercial Frango" },
        { id: "ABATE FOMENTO AVICOLA", label: "Fomento Avícola" },
        { id: "ABATE QUALIDADE", label: "Qualidade" },
        { id: "ABATE ADMIN-ABATE", label: "Administrativo" },
      ],
    },

    administrativo: [
      { id: "ADMIN AREA AMBIENTAL", label: "Área Ambiental" },
      { id: "ADMIN AREA TECNICA", label: "Área Técnica" },
      { id: "ADMIN AUDITORIA INTERNA", label: "Auditoria Interna" },
      { id: "ADMIN COMERCIAL GRAOS", label: "Comercial" },
      { id: "ADMIN COMPRAS", label: "Compras" },
      { id: "ADMIN CONTABIL", label: "Contábil" },
      { id: "ADMIN FINANCEIRO", label: "Financeiro" },
      { id: "ADMIN JURIDICO", label: "Jurídico" },
      { id: "ADMIN LIMPEZA", label: "Limpeza" },
      { id: "ADMIN MANUTENCAO", label: "Manutenção" },
      { id: "ADMIN RECURSOS HUMANOS", label: "Recursos Humanos" },
      { id: "ADMIN TI/CPD", label: "TI/CPD" },
    ],

    carregando: false,
  }),

  computed: {
    podeContinuar() {
      return !!(
        this.bancoSelecao.unidade ||
        this.bancoSelecao.operadorProducao ||
        this.bancoSelecao.servicosExternos ||
        this.bancoSelecao.manutencao ||
        this.bancoSelecao.outrasAreas ||
        this.bancoSelecao.administrativo
      );
    },
  },

  methods: {
    ...mapMutations("candidaturainterna", [
      "setStep",
      "setTipoSelecao",
      "setVagaSelecionada",
      "setBancoSelecao",
    ]),

    formatData(date) {
      if (!date) return "-";
      const s = String(date).trim().replaceAll("/", "-");
      const parts = s.split("-").map((p) => p.trim());
      if (parts.length !== 3) return String(date);
      const [a, b, c] = parts;
      if (a.length === 4)
        return `${c.padStart(2, "0")}/${b.padStart(2, "0")}/${a}`;
      if (c.length === 4)
        return `${a.padStart(2, "0")}/${b.padStart(2, "0")}/${c}`;
      return String(date);
    },

    // ✅ vaga normal: abre dialog e depois vai pro step 3
    abrirDetalhesVaga(vaga) {
      this.vagaTemp = vaga;
      this.dialogDetalhes = true;
    },

    candidatarVaga(vaga) {
      this.vagaTemp = vaga;
      this.dialogConfirmaVaga = true;
    },

    confirmarCandidatura() {
      if (!this.vagaTemp) return;

      this.setTipoSelecao("VAGA");
      this.setVagaSelecionada(this.vagaTemp);
      this.setStep(2);

      this.dialogConfirmaVaga = false;
      this.dialogDetalhes = false;
      this.vagaTemp = null;
    },

    limparSelecoesBanco(except) {
      const keys = [
        "unidade",
        "operadorProducao",
        "servicosExternos",
        "manutencao",
        "outrasAreas",
        "administrativo",
      ];

      keys.forEach((k) => {
        if (k !== except) this.bancoSelecao[k] = null;
      });
    },

    selecionaUnidade(unidade) {
      const jaSelecionada = this.bancoSelecao.unidade === unidade;
      this.limparSelecoesBanco("unidade");
      this.bancoSelecao.unidade = jaSelecionada ? null : unidade;
    },

    onSelecionaGrupo(grupo) {
      this.limparSelecoesBanco(grupo);
    },

    async continuarBanco() {
      try {
        this.setTipoSelecao("BANCO");
        this.setBancoSelecao(this.bancoSelecao);

        const vagaBanco =
          this.bancoSelecao.operadorProducao ||
          this.bancoSelecao.servicosExternos ||
          this.bancoSelecao.manutencao ||
          this.bancoSelecao.outrasAreas ||
          this.bancoSelecao.administrativo ||
          this.bancoSelecao.unidade; // opcional

        if (!vagaBanco) {
          this.$toasted.error("Selecione uma vaga/área no Banco de Talentos.");
          return;
        }

        const res = await axios.post(
          "/colaborador/candidatura-interna?funcao=ATUALIZAR-AREAS-INTERESSE",
          { areas: [vagaBanco] },
        );

        if (res.data?.success) {
          this.setStep(2);
        } else {
          this.$toasted.error(
            res.data?.msg || "Falha ao salvar área de interesse",
          );
        }
      } catch (e) {
        this.$toasted.error("Falha ao salvar área de interesse");
      }
    },

    async getVagas() {
      this.carregando = true;
      try {
        const res = await axios.get(
          "/colaborador/candidatura-vagas?funcao=LISTAR-VAGAS&tipo=colaborador",
        );
        const maybeArray = res?.data?.data?.data ?? res?.data?.data ?? [];
        this.vagas = Array.isArray(maybeArray) ? maybeArray : [];
      } catch (e) {
        this.vagas = [];
      } finally {
        this.carregando = false;
      }
    },
  },

  async mounted() {
    await this.getVagas();
  },
};
</script>

<style scoped>
.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
